import { render } from "./VoucherOT.vue?vue&type=template&id=ceebf8ee"
import script from "./VoucherOT.vue?vue&type=script&lang=js"
export * from "./VoucherOT.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\COSMI\\Desktop\\appwebantiguo\\vue-op-vanguardia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__